<kilowant-header [isHome]="true" title="Start kilowant" linkHome="/"></kilowant-header>
<div class="overWrapper">
    <ol class="wrapperMain kilowant-list">
        <li class="home-step" [class]="(step==1)?'':('inactive'+((step>1)?' with-link':''))" #step1>
            <h3 class="title" #body>
                <span>Upload or Photo P.1 of your Bill</span>
            </h3>
            @if (step>1) {
            <div class="inactive-step" (click)="gotoHome()"></div>
            }
        </li>
        <li class="home-step" [class]="(step==2)?'':('inactive'+((step>2)?' with-link':''))" #step2>
            <h3>Complete Account Details</h3>
            @if (step>2) {
            <div class="inactive-step" (click)="gotoAccountDetails()"></div>
            }
            @if (step==2) {
            <kilowant-account-add-step2 [(account)]="account" [user]="null"
                                        (taxCertificateChanged)="setTaxtCertificate($event)"
                                        (deleteTaxExemptCertificateChanged)="setDeleteTaxExemptCertificateChanged($event)"
                                        [byAdvisor]="false" (return)="finishStep2($event)"></kilowant-account-add-step2>
            }
        </li>

        <li class="home-step" [class]="(step==3)?'':('inactive'+((step>3)?' with-link':''))" #step3>
            <h3>Confirm Supply Service Provider</h3>
            @if (step==3) {
            <kilowant-account-add-step3 [(account)]="account" [user]="null"
                                        (existingContractIdChanged)="setExistingContractId($event)"
                                        (existingContractChanged)="setExistingContract($event)"
                                        [byAdvisor]="false" (return)="finishStep3($event)"></kilowant-account-add-step3>
            }
        </li>
    </ol>
</div>